import { AUTH_UNAUTHENTICATED_EVENT } from '@aposphaere/core-kit'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { LOGIN_ROUTE } from '../../routes'

const Events: React.FC = () => {
  const history = useHistory()

  useEffect(() => {
    const handler = () => {
      const PUBLIC_ROUTES = ['/login', '/reset-password']

      if (!PUBLIC_ROUTES.includes(window.location.pathname)) {
        history.push(LOGIN_ROUTE)
      }
    }

    window.addEventListener(AUTH_UNAUTHENTICATED_EVENT, handler)

    return () => {
      window.removeEventListener(AUTH_UNAUTHENTICATED_EVENT, handler)
    }
  }, [history])

  return null
}

export default Events
